@if (initialized) {
<div [attr.id]="id" class="form-panel">
  <form [formGroup]="form">
    <div class="form-row">
      @for (fld of displayFields; track fld) {
      <div class="form-col" [ngClass]="fld.displayLayout ? fld.displayLayout : ''">
        @if (fld.controlType === uiControlType.Checkbox) {
        <div class="mat-mdc-text-field-wrapper">
          <mat-checkbox [attr.id]="id + '-' + fld.flatName" [formControlName]="fld.flatName">
            {{ fld.label }}
          </mat-checkbox>
        </div>
        } @if (fld.controlType === uiControlType.RadioButton) {
        <div class="mat-mdc-text-field-wrapper">
          <mat-radio-group [attr.id]="id + '-' + fld.flatName" [formControlName]="fld.flatName">
            @for (option of fld.selectOptions; track option) {
            <mat-radio-button [value]="option.value">
              {{ option.text }}
            </mat-radio-button>
            }
          </mat-radio-group>
        </div>
        } @if (fld.controlType === uiControlType.Autocomplete) {
        <div>
          <ignite-auto-complete
            [id]="id + '-' + fld.flatName"
            [label]="fld.label"
            [selectOptions]="fld.selectOptions"
            [placeholder]="fld.placeHolder"
            [frmCtrl]="form.get(fld.flatName)"
            [hint]="fld.hint"
            [required]="fld.required"
          ></ignite-auto-complete>
        </div>
        } @if (fld.controlType === uiControlType.InputTelephone) {
        <div>
          <ignite-telephone-input
            [id]="id + '-' + fld.flatName"
            [label]="fld.label"
            [countryCallingCodes]="fld.countryCallingCodes"
            [placeholder]="fld.placeHolder"
            [formControlName]="fld.flatName"
            [required]="fld.required"
            [hint]="fld.hint"
          ></ignite-telephone-input>
        </div>
        } @if (fld.controlType === uiControlType.Label) {
        <div>
          <ignite-label [id]="id + '-' + fld.flatName" [controlName]="fld.flatName"></ignite-label>
        </div>
        } @if (fld.controlType === uiControlType.CustomContent) {
        <div>
          @if (fld.customComponent) {
          <ignite-grid-custom [component]="fld.customComponent" [value]="data"></ignite-grid-custom>
          }
        </div>
        } @if ( fld.controlType !== uiControlType.Checkbox && fld.controlType !== uiControlType.RadioButton && fld.controlType !==
        uiControlType.Autocomplete && fld.controlType !== uiControlType.InputTelephone && fld.controlType !== uiControlType.Label &&
        fld.controlType !== uiControlType.Hidden && fld.controlType !== uiControlType.CustomContent ) {
        <mat-form-field
          [attr.id]="id + '-' + fld.flatName"
          [hideRequiredMarker]="true"
          appearance="outline"
          [class.is-empty]="getFieldValue(fld.flatName) === ''"
        >
          @if (fld.label !== '') {
          <mat-label floatLabel>{{ fld.label }}</mat-label>
          } @if (fld.controlType === uiControlType.InputText) {
          <div>
            <input matInput [formControlName]="fld.flatName" [placeholder]="fld.placeHolder" [attr.maxLength]="fld.maxLength" trim="blur" />
          </div>
          } @if (fld.controlType === uiControlType.InputNumber) {
          <div>
            <input type="number" matInput [formControlName]="fld.flatName" [placeholder]="fld.placeHolder" />
          </div>
          } @if (fld.controlType === uiControlType.TextArea) {
          <div>
            <textarea
              matInput
              [formControlName]="fld.flatName"
              [placeholder]="fld.placeHolder"
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
            ></textarea>
          </div>
          } @if (fld.controlType === uiControlType.InputPassword) {
          <div>
            <ignite-password [frmCtrl]="fld.flatName" [placeholder]="fld.placeHolder"></ignite-password>
          </div>
          } @if (fld.controlType === uiControlType.InputDate) {
          <div>
            <input
              matInput
              class="ignite-date-input"
              [matDatepicker]="picker"
              [formControlName]="fld.flatName"
              [placeholder]="fld.placeHolder"
            />
            <mat-datepicker ignite-date-picker #picker color="primary"></mat-datepicker>
          </div>
          } @if (fld.controlType === uiControlType.DropdownList) {
          <div>
            <mat-select ignite-select [formControlName]="fld.flatName" disableOptionCentering="true">
              <mat-option [value]="null"></mat-option>
              @for (option of fld.selectOptions; track option) {
              <mat-option [value]="option.value">
                {{ option.text }}
              </mat-option>
              }
            </mat-select>
          </div>
          } @if (fld.controlType === uiControlType.MultiSelect) {
          <div>
            <mat-select ignite-select [formControlName]="fld.flatName" multiple disableOptionCentering="true">
              @for (option of filterOptions(fld); track option) {
              <mat-option [value]="option.value">
                {{ option.text }}
              </mat-option>
              }
            </mat-select>
          </div>
          } @if (form.get(fld.flatName).enabled && fld.hint) {
          <mat-hint>{{ fld.hint }}</mat-hint>
          } @if (form.get(fld.flatName).hasError('required')) {
          <mat-error>{{ fld.label }} is required</mat-error>
          } @for (cm of fld.customMessages; track cm) {
          <mat-error class="ignite-custom-error">
            @if (form.get(fld.flatName).hasError(cm.key)) {
            <span>{{ cm.message }}</span>
            }
          </mat-error>
          }
        </mat-form-field>
        }
      </div>
      }
    </div>
    @if (!readOnly) {
    <div class="ignite-buttons-container">
      <div class="ignite-buttons">
        <div class="ignite-button-wrapper">
          @if (isAddMode) {
          <button id="ignite-grid-add-button" [disabled]="isSaving" mat-button color="primary" class="ignite-button" (click)="save()">
            Add {{ name }}
          </button>
          } @if (!isAddMode) {
          <button id="ignite-grid-save-button" [disabled]="isSaving" mat-button color="primary" class="ignite-button" (click)="save()">
            {{ saveButtonLabel ? saveButtonLabel : "Save " + name }}
          </button>
          }
        </div>
        <div class="ignite-button-wrapper">
          <button id="ignite-grid-cancel-button" mat-button color="secondary" class="ignite-button" type="button" (click)="cancel($event)">
            Cancel
          </button>
        </div>
      </div>
      <hr />
    </div>
    }
  </form>
</div>
}
